<div class="admin-content">
  <cei-admin-page-cabecalho
    [titulo]="tituloPagina"
    [rotaLista]="pessoaId > 0 ? '/admin/pessoas' : null"
    [rotaVoltar]="pessoaId > 0 ? ['/admin/pessoas/detalhe', pessoaId] : '/admin/pessoas'"
  />
  <admin-pessoa-usuario-form
    [form]="form"
    [formVersao]="formVersao"
    [mode]="pessoaId > 0 ? 'edit' : 'create'"
    [pessoaId]="pessoaId || undefined"
    (submitForm)="onSubmit($event)"
    (fotoSelected)="onFotoSelected($event)"
    (fotoRemoved)="onFotoRemoved()"
  />
</div>
